






























import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { PermissionModule } from '@/store/modules/permission'
import { SettingsModule } from '@/store/modules/settings'
import SidebarItem from './SidebarItem.vue'
import SidebarLogo from './SidebarLogo.vue'
import variables from '@/styles/_variables.scss'

@Component({
  name: 'SideBar',
  components: {
    SidebarItem,
    SidebarLogo
  }
})
export default class extends Vue {
  get sidebar () {
    return AppModule.sidebar
  }

  get routes () {
    let routes = []
    // 去重path*  有可能存在两个路径都为*的路由
    if (PermissionModule.routes.filter(item => item.path === '*').length >= 2) {
      const index = PermissionModule.routes.findIndex(item => item.path === '*')
      routes = PermissionModule.routes.filter((item, index2) => index2 !== index)
      return routes
    } else {
      return PermissionModule.routes
    }
    // 原来的写法
    // return PermissionModule.routes
  }

  get showLogo () {
    return SettingsModule.showSidebarLogo
  }

  get menuActiveTextColor () {
    if (SettingsModule.sidebarTextTheme) {
      return SettingsModule.theme
    } else {
      return variables.menuActiveText
    }
  }

  get variables () {
    return variables
  }

  get activeMenu () {
    const route = this.$route
    const { meta, path } = route
    if (meta?.activeMenu) {
      return meta.activeMenu
    }
    return path
  }

  get isCollapse () {
    return !this.sidebar.opened
  }

  /**
   * 非折叠侧栏时，默认展开的子菜单 index（el-menu default-openeds）。
   * 路由 meta.sidebarDefaultOpen === false 时不默认展开（见 business.ts 父级 meta）。
   */
  get openKeys () {
    return this.routes
      .filter((route: any) => {
        if (!route.path || !route.children || !route.children.length) return false
        if (route.meta && route.meta.hidden) return false
        if (route.meta && route.meta.sidebarDefaultOpen === false) return false
        return true
      })
      .map((route: any) => route.path)
  }
}
